import { createReducer } from '@reduxjs/toolkit';

import initialState from './fees.initialState';
import { ACTION_TYPES } from './fees.constant';

const handleResetState = () => initialState;

const handleFetchStart = (state) => {
  state.loading = true;
};

const handleFetchError = (state) => {
  state.loading = false;
};

const handleFetchSuccess = (state, action) => {
  state.loading = false;
  state.data = action.payload;
};

const handleFetchSuccessLink = (state, action) => {
  state.loading = false;
  state.link_data = action.payload;
};

export default createReducer(initialState, {
  [ACTION_TYPES.RESET.STATE]: handleResetState,
  [ACTION_TYPES.FETCH.START]: handleFetchStart,
  [ACTION_TYPES.FETCH.ERROR]: handleFetchError,
  [ACTION_TYPES.FETCH.SUCCESS]: handleFetchSuccess,
  [ACTION_TYPES.FETCH.SUCCESS_LINK]: handleFetchSuccessLink,
});
